function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36 15.5V18.5C36 18.77 35.77 19 35.5 19H14.5H14.49C14.21 18.99 13.99 18.77 13.99 18.49V15.49C13.98 15.21 14.21 14.98 14.48 14.98H35.48H35.47C35.74 14.97 35.97 15.2 35.97 15.47L36 15.5ZM29 23.5C29 23.77 28.77 24 28.5 24H21.5H21.49C21.21 23.99 20.99 23.77 20.99 23.49V22.49C20.98 22.21 21.21 21.98 21.48 21.98H28.48H28.47C28.74 21.97 28.97 22.2 28.97 22.47V23.47L29 23.5ZM34.5 20H15.5H15.49C15.21 20 14.99 20.22 14.99 20.5V33.5C14.99 34.32 15.66 35 16.49 35H33.49C34.31 35 34.99 34.32 34.99 33.5V20.5C34.99 20.22 34.76 20 34.49 20H34.5Z"
});

function SvgIc5D5F9FfeFc0611Eb9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5D5F9FfeFc0611Eb9A030242Ac130003);
export default ForwardRef;